import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '@/components/base/Logo';
import Icon from '@/components/base/Icon';
import { useCategories } from '@/hooks/useBlogData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const categories = useCategories();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-white/95 backdrop-blur shadow-sm'
          : 'bg-white'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center shrink-0">
            <Logo className="h-10 md:h-12 w-auto object-contain" />
          </Link>

          {/* Desktop menu */}
          <div className="hidden lg:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                isHome ? 'text-emerald-700 bg-emerald-50' : 'text-gray-700 hover:text-emerald-700 hover:bg-gray-50'
              }`}
            >
              Blog
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/categoria/${cat.slug}`}
                className="px-3 py-2 text-sm font-medium text-gray-700 rounded-lg hover:text-emerald-700 hover:bg-gray-50 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <Icon name={mobileOpen ? 'close' : 'menu'} size={24} />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t shadow-lg max-h-[80vh] overflow-y-auto">
          <div className="flex flex-col gap-1 px-4 py-4">
            <Link
              to="/"
              className={`text-base font-medium px-3 py-2.5 rounded-lg ${
                isHome ? 'text-emerald-700 bg-emerald-50' : 'text-gray-700'
              }`}
            >
              Blog
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/categoria/${cat.slug}`}
                className="text-base font-medium text-gray-700 px-3 py-2.5 rounded-lg hover:bg-gray-50"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
